<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M623 1190 c-41 -25 -53 -48 -53 -105 0 -38 5 -52 28 -75 38 -38 89
-47 136 -25 87 41 88 168 2 209 -45 21 -74 20 -113 -4z m111 -41 c20 -16 26
-29 26 -59 0 -44 -35 -80 -77 -80 -30 0 -83 51 -83 80 0 29 53 80 83 80 13 0
36 -9 51 -21z"
      />
      <path
        d="M938 1054 c-80 -43 -75 -170 8 -209 41 -19 58 -19 100 1 42 20 64 59
64 111 0 87 -94 140 -172 97z m104 -38 c26 -19 39 -62 28 -90 -11 -30 -47 -56
-77 -56 -36 0 -76 42 -76 80 0 60 78 102 125 66z"
      />
      <path
        d="M833 970 c-40 -24 -62 -57 -70 -104 -6 -36 -5 -36 30 -36 38 0 47 12
47 61 0 16 7 45 14 64 8 19 14 35 13 35 -1 0 -16 -9 -34 -20z"
      />
      <path
        d="M1134 958 c8 -18 17 -54 21 -80 7 -46 8 -48 41 -48 31 0 34 3 34 29
0 36 -36 90 -77 114 l-33 19 14 -34z"
      />
      <path
        d="M595 920 c-46 -14 -96 -71 -106 -122 -10 -52 -11 -144 -3 -186 l6
-31 153 -3 153 -3 26 86 c15 48 33 92 41 99 19 16 19 47 0 80 -14 25 -14 25
-15 3 0 -21 -5 -23 -55 -23 l-56 0 7 35 c13 72 15 70 -56 72 -36 1 -79 -2 -95
-7z m117 -77 c3 -47 4 -48 38 -51 19 -1 45 -5 57 -7 20 -5 21 -7 7 -34 -8 -16
-20 -52 -27 -80 l-12 -51 -127 0 -128 0 0 80 c0 48 6 95 14 115 20 46 69 75
128 75 l47 0 3 -47z"
      />
      <path
        d="M63 805 c-33 -23 -48 -78 -30 -114 15 -30 214 -278 241 -301 9 -7 39
-15 66 -18 l50 -5 0 -73 0 -74 -40 0 -40 0 0 -65 0 -65 195 0 195 0 0 65 0 65
-45 0 -45 0 0 75 0 75 62 0 62 0 58 -57 c48 -47 63 -57 93 -57 50 0 85 36 85
87 0 36 -7 47 -77 119 -43 44 -90 86 -105 94 -20 11 -74 14 -221 14 l-194 0
-87 110 c-48 60 -97 117 -109 125 -28 19 -86 19 -114 0z m185 -167 l103 -128
208 0 208 0 76 -79 c42 -43 77 -83 77 -88 0 -12 -22 -33 -35 -33 -6 0 -38 27
-72 60 l-60 60 -223 2 -224 3 -112 135 c-110 132 -127 163 -102 188 26 26 54
5 156 -120z m302 -343 l0 -75 -55 0 -55 0 0 75 0 75 55 0 55 0 0 -75z m90
-140 c0 -13 -22 -15 -134 -15 -123 0 -157 6 -139 24 3 3 66 6 140 6 112 0 133
-2 133 -15z"
      />
      <path
        d="M908 774 c-33 -17 -49 -46 -77 -139 l-20 -69 83 -86 c46 -47 86 -95
90 -107 6 -20 14 -23 59 -23 49 0 164 26 180 40 9 8 -74 293 -99 341 -7 15
-29 34 -48 43 -42 20 -132 20 -168 0z m166 -46 c19 -17 37 -61 69 -166 51
-165 53 -160 -53 -169 l-57 -5 -90 93 -90 93 19 65 c28 93 47 111 119 111 46
0 63 -5 83 -22z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
